;(function () {
  'use strict'
  angular
    .module('contrast.preferences')
    .factory(
      'preferencesService',
      function preferencesServiceFactory(ServiceUtils, preferencesApiConfig) {
        'ngInject'

        return {
          getValue: getValue,
          getBooleanValue: getBooleanValue
        }

        function getValue(name) {
          return preferencesApiConfig
            .getValue(name)
            .then(ServiceUtils.handleResolve('data.preference.value'))
            .catch(ServiceUtils.handleError)
        }

        function getBooleanValue(name) {
          return getValue(name).then(function (preferenceValue) {
            return preferenceValue === 'true'
          })
        }
      }
    )
})()
